import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, Loader2, Check } from "lucide-react";
import api from "../lib/api";

export const ShareTeamButton = ({ pulseId }) => {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/vision-pulse/${pulseId}/share-info`).then(({ data }) => setInfo(data)).catch(() => {});
  }, [pulseId]);

  const share = async () => {
    if (!window.confirm(`Email this pulse to ${info.recipients} teammate${info.recipients === 1 ? "" : "s"}?`)) return;
    setBusy(true);
    try {
      const { data } = await api.post(`/vision-pulse/${pulseId}/share`);
      setInfo({ ...info, shared_at: new Date().toISOString(), shared_with: data.recipients });
      toast.success(`Shared with ${data.recipients} teammate${data.recipients === 1 ? "" : "s"}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't share");
    } finally { setBusy(false); }
  };

  if (!info) return null;
  if (info.shared_at) {
    return (
      <span data-testid="pulse-shared-badge" className="px-3 py-2 text-xs font-bold uppercase tracking-wider text-[#0033FF] inline-flex items-center gap-2">
        <Check className="w-3 h-3" /> Shared with {info.shared_with} teammate{info.shared_with === 1 ? "" : "s"}
      </span>
    );
  }
  return (
    <button onClick={share} disabled={busy || !info.recipients} data-testid="pulse-share-team-btn"
      title={info.recipients ? "" : "Add seats or team members with emails first"}
      className="bg-[#0033FF] text-white px-3 py-2 text-xs font-bold uppercase tracking-wider hover:bg-zinc-900 disabled:opacity-40 inline-flex items-center gap-2">
      {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Send className="w-3 h-3" />} Share with team ({info.recipients})
    </button>
  );
};
